import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import "./ChanelHome.scss";
import { useTranslation } from "react-i18next";
import {
  AwardFill,
  ChatDotsFill,
  ClockFill,
  EyeFill
} from "react-bootstrap-icons";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import ReplayPreview from "./ReplayPreview";
import { EmotIcons } from "../../api/ReplayVariables";
import NoResults from "./NoResults";

const responsive = {
  size: {
    breakpoint: {
      max: 600,
      min: 0,
      partialVisibilityGutter: 350
    },
    items: 1
  }
};
for (var k = 0; k < 4; k++) {
  responsive["size" + k] = {
    breakpoint: {
      max: k === 3 ? 100000 : 600 + (k + 1) * 355,
      min: 600 + k * 355,
      partialVisibilityGutter: 350
    },
    items: 2 + k
  };
}
function ChanelHome({ data }) {
  const [loaded, setLoaded] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setLoaded(false);
    let timer = setTimeout(() => {
      setLoaded(true);
    }, 1000);
    //console.debug("tab???", responsive);

    //FETCH HAND DETAILS
    //console.log("chanelHome effect");
    return () => {
      //console.log("chanelHome done");
      clearTimeout(timer);
    };
  }, [data]);

  if (data !== null) {
    return (
      <>
        {data.featured ? (
          <div className="featured-container">
            <div className={"featured " + (loaded ? "loaded" : "")}>
              <ReplayPreview
                hand={data.featured}
                featured={true}
              ></ReplayPreview>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div
          className={
            "chanel-sections-container d-flex flex-column " +
            (loaded ? "loaded" : "")
          }
        >
          {data.last.length > 0 ? (
            <>
              <section className="chanel-section">
                <Link to="./replays">
                  <ClockFill />
                  {t("navigation.rankings.last")}
                </Link>
              </section>
              <div className="d-flex denis">
                <Carousel
                  responsive={responsive}
                  draggable={false}
                  className="chanel-replays"
                >
                  {data.last.map((hand, index) => {
                    return (
                      <ReplayPreview key={hand.id} hand={hand}></ReplayPreview>
                    );
                  })}
                </Carousel>
                <div className="gap">&nbsp;&nbsp;&nbsp;</div>
              </div>
            </>
          ) : (
            <NoResults />
          )}
          {data.popular.length > 0 ? (
            <>
              <section className="chanel-section">
                <Link to="./replays/viewed">
                  <EyeFill />
                  {t("navigation.rankings.viewed")}
                </Link>
              </section>
              <div className="d-flex">
                <Carousel
                  responsive={responsive}
                  draggable={false}
                  className="chanel-replays"
                >
                  {data.popular.map((hand, index) => {
                    return (
                      <ReplayPreview key={hand.id} hand={hand}></ReplayPreview>
                    );
                  })}
                </Carousel>
                <div className="gap">&nbsp;&nbsp;&nbsp;</div>
              </div>
            </>
          ) : (
            <></>
          )}
          {data.commented.length > 0 ? (
            <>
              <section className="chanel-section">
                <Link to="./replays/commented">
                  <ChatDotsFill />
                  {t("navigation.rankings.commented")}
                </Link>
              </section>
              <div className="d-flex">
                <Carousel
                  responsive={responsive}
                  draggable={false}
                  className="chanel-replays"
                >
                  {data.commented.map((hand, index) => {
                    return (
                      <ReplayPreview key={hand.id} hand={hand}></ReplayPreview>
                    );
                  })}
                </Carousel>
                <div className="gap">&nbsp;&nbsp;&nbsp;</div>
              </div>
            </>
          ) : (
            <></>
          )}
          {data.voted.length > 0 ? (
            <>
              <section className="chanel-section">
                <Link to="./replays/voted">
                  <AwardFill />
                  {t("navigation.rankings.voted")}
                </Link>
              </section>
              <div className="d-flex">
                <Carousel
                  responsive={responsive}
                  draggable={false}
                  className="chanel-replays"
                >
                  {data.voted.map((hand, index) => {
                    return (
                      <ReplayPreview key={hand.id} hand={hand}></ReplayPreview>
                    );
                  })}
                </Carousel>
                <div className="gap">&nbsp;&nbsp;&nbsp;</div>
              </div>
            </>
          ) : (
            <></>
          )}
          {[1, 2, 3, 4].map((voteNum) => {
            return data["vote" + voteNum].length > 0 ? (
              <Fragment key={"vote" + voteNum}>
                <section
                  className={"chanel-section vote-section vote" + voteNum}
                >
                  <Link to={"./replays/vote=" + voteNum}>
                    <img src={EmotIcons["VOTE" + voteNum]} alt="" />
                    {t("replayApp.votes." + voteNum)}
                  </Link>
                </section>
                <div className="d-flex">
                  <Carousel
                    responsive={responsive}
                    draggable={false}
                    className="chanel-replays"
                  >
                    {data["vote" + voteNum].map((hand, index) => {
                      return (
                        <ReplayPreview
                          key={hand.id}
                          hand={hand}
                        ></ReplayPreview>
                      );
                    })}
                  </Carousel>
                  <div className="gap">&nbsp;&nbsp;&nbsp;</div>
                </div>
              </Fragment>
            ) : (
              <Fragment key={"vote" + voteNum}></Fragment>
            );
          })}
        </div>
      </>
    );
  } else {
    return <></>;
  }
}
export default ChanelHome;
